<template>
  <b-modal
    :id="id"
    size="lg"
    :title="trans('choose_a_client')"
    :ok-title="trans('choose')"
    :ok-disabled="busy || !client"
    :cancel-title="trans('cancel')"
    @ok="onChoose"
    @shown="onShown"
    @hidden="onHidden"
  >
    <div v-if="visible">
      <b-row v-if="organization.has_memberships">
        <b-col>
          <b-form-group>
            <b-form-checkbox v-model="member_only" :disabled="busy" @change="onSearch">
              {{ trans('members_only') }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <search-form v-model="search" @input="onSearch" :disabled="busy" />
        </b-col>
      </b-row>
      <b-overlay :show="busy" class="mt-2">
        <b-table
          ref="table"
          id="clients"
          class="bg-white table-row-click"
          small
          hover
          responsive
          show-empty
          :per-page="perPage"
          :current-page="currentPage"
          :fields="fields"
          :items="provider"
          :tbody-tr-class="rowClass"
          @row-clicked="onRowClick"
        >
          <template v-slot:empty>
            <h4 v-if="busy" align="center">
              <i class="fa fa-circle-notch fa-spin"></i>
              {{ trans('loading') }}
            </h4>
            <p v-if="!busy" align="center">{{ trans('none') }}</p>
          </template>
        </b-table>
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          aria-controls="clients"
          align="center"
          :disabled="busy"
        ></b-pagination>
      </b-overlay>
    </div>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import SearchForm from './../../../common/components/SearchRecipientsForm'

  export default {
    props: {
      organization: Object,
      id: {
        type: String,
        default: 'admin-choose-client-modal'
      },
      type: {
        type: String,
        default: 'client', // member, client
      },
    },
    components: {
      SearchForm,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        search: null,
        recipients: [],
        search: {
          name: null,
          mobile: null,
          email: null
        },
        items: null,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        client: null,
        member_only: this.type == 'member',
        visible: false,
      }
    },
    computed: {
      fields() {
        return _.compact([
          {key: 'name', label: trans('name')},
          {key: 'email', label: trans('email')},
          {key: 'mobile', label: trans('mobile')},
          this.organization.has_memberships ? {
            key: 'membership',
            label: trans('membership'),
            formatter(value, key, item) {
              return item.membership ? item.membership.name : null
            },
          } : null,
          this.organization.has_memberships ? {
            key: 'expired_at',
            label: trans('expires'),
            formatter(value, key, item) {
              return item.membership && item.membership.expired_at ?
                moment(item.membership.expired_at).format('LL') :
                null
            },
          } : null,
        ],)
      },
    },
    methods: {
      onShown() {
        this.member_only = this.type == 'member'
        this.visible = true
      },
      onHidden() {
        this.visible = false
        this.busy = false
        this.error = null
        this.client = null
      },
      onChoose() {
        this.$emit('chosen', this.client)
      },
      rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.selected) return 'table-primary'
      },
      onRowClick(client) {
        if (this.client && this.client.id != client.id) this.client.selected = false
        this.client = client
        this.client.selected = true
      },
      onSearch() {
        this.currentPage = 1
        this.onRefresh()
      },
      onRefresh() {
        this.$refs.table.refresh()
      },
      buildItems(clients) {
        return _.reduce(clients || [], (clients, client) => {
          if (!client.recipient_id && !client.id) return clients
          client.selected = false
          if (!client.membership && client.memberships) client.membership = client.memberships[0] || null
          if (!client.membership && client.extra && client.extra.membership) client.membership = client.extra.membership
          clients.push(client)
          return clients
        }, [])
      },
      provider() {
        this.busy = true
        this.error = null
        let query = `?client&show=memberships,account_members,contacts&page=${this.currentPage}&per_page=${this.perPage}`
        if (this.search.name) query += `&name=${encodeURIComponent(this.search.name)}`
        if (this.search.mobile) query += `&mobile=${encodeURIComponent(this.search.mobile)}`
        if (this.search.email) query += `&email=${encodeURIComponent(this.search.email)}`
        let url = this.organization.has_memberships && this.member_only ?
          `/organization/${this.organization.id}/recipient/member${query}` :
          `/organization/${this.organization.id}/client/list${query}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.currentPage = response.data.current_page
          this.perPage = response.data.per_page
          this.totalRows = response.data.total
          this.items = this.buildItems(response.data.data)
          return this.items
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.items = []
          return this.items
        })
      },
    },
    mounted() {
      window.adminChooseClientModal = this
    },
  }
</script>